import { useEffect } from "react";
import ReactGA from "react-ga4";
import useAnalyticsEventTracker from "../../core/service/useAnalyticsEventTracker";
import PickupStudentScanMobile from "./pickupStudentScanMobile.jsx";
import { BrowserView, MobileView } from "react-device-detect";
const PickupStudentScanComponent = () => {
  const gaEventTracker = useAnalyticsEventTracker("ScanPickupStudent");
  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname + window.location.search,
      title: "Scan Pickup Student",
    });
    // let mediaStream: any;
    // navigator.mediaDevices
    //   .getUserMedia({ video: true })
    //   .then(function (stream) {
    //     mediaStream = stream;
    //     // Kamera berhasil diakses
    //     console.log("access granted");
    //   })
    //   .catch(function (err) {
    //     // Handle error jika kamera tidak dapat diakses
    //   });

    // if (mediaStream) {
    //   const tracks = mediaStream.getTracks();
    //   tracks.forEach((track: any) => track.stop()); // Stop all tracks (video/audio)
    //   console.log("Camera access stopped.");
    // }
  }, []);
  return (
    <>
      <BrowserView>
        <PickupStudentScanMobile></PickupStudentScanMobile>
      </BrowserView>
      <MobileView>
        <PickupStudentScanMobile></PickupStudentScanMobile>
      </MobileView>
    </>
  );
};

export default PickupStudentScanComponent;
